import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import Error404 from 'src/views/Error404';
import Login from 'src/views/Login';
import Profil from 'src/views/Profile';
import UnauthorizedView from 'src/views/Unauthorized';
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';


export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/Unauthorized',
    component: ErrorLayout,
    routes: [
      {
        path: '/Unauthorized',
        exact: true,
        component: UnauthorizedView
      },
      {
        component: () => <Redirect to="/Unauthorized" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/Dashboard',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Dashboard'))
      },
      {
        path: '/Organization/TicketManagement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/TicketManagement'))
      },
      {
        path: '/Operations/ShipToManagement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/ShipToManagement'))
      },
      {
        path: '/Operations/MaterialManagement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MaterialManagement'))
      },
      {
        path: '/TradePartner',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/TradePartner'))
      },
      {
        path: '/Organization/ExcelUpload',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/ExcelUpload'))
      },
      {
        path: '/ProductRelease',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/ProductRelease'))
      },
      {
        path: '/ProductReleaseAnnouncement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/ProductReleaseAnnouncement'))
      },
      {
        path: '/Catalog/ServiceShopPostCodeMap',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ServiceShopPostCodeMap'))
      },
      {
        path: '/Catalog/MonthlyTransportation',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/MonthlyTransportation'))
      },
      {
        path: '/Catalog/WarrantyTimeExceptions',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/WarrantyTimeExceptions'))
      },
      {
        path: '/Catalog/Channel',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Channel'))
      },
      {
        path: '/Catalog/VerificationRules',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/VerificationRules'))
      },
      {
        path: '/Catalog/VerificationRules/AddVerificationRule',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/VerificationRules/AddVerificationRule'))
      },
      {
        path: '/Catalog/SurveyQuestionAnswer',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/SurveyQuestionAnswer'))
      },
      {
        path: '/Catalog/SurveyQuestionAnswer/AddSurveyQuestion',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/SurveyQuestionAnswer/AddSurveyQuestion'))
      },
      {
        path: '/Catalog/SurveyQuestionAnswer/AddSurveyAnswer',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/SurveyQuestionAnswer/AddSurveyAnswer'))
      },
      {
        path: '/Catalog/SurveyQuestionAnswer/AddSurveyHeader',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/SurveyQuestionAnswer/AddSurveyHeader'))
      },
      {
        path: '/Catalog/Translation',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Translation'))
      },
      {
        path: '/Catalog/Channel/AddChannel',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Channel/AddChannel'))
      },
      {
        path: '/Catalog/CommentType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/CommentType'))
      },
      ,
      {
        path: '/Catalog/CommentType/AddCommentType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/CommentType/AddCommentType'))
      },
      {
        path: '/Catalog/Priority',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Priority'))
      },
      {
        path: '/Catalog/Priority/AddPriority',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Priority/AddPriority'))
      },
      {
        path: '/Catalog/ApplicationType-ProductMatching',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ApplicationType-ProductMatching/ApplicationTypeProductMatching'))
      },
      {
        path: '/Catalog/TypeProductEdit',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/TypeProductEdit/TypeProductEdit'))
      },
      {
        path: '/Catalog/SKU-Attachments',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/SKUAttachments/SKUAttachments'))
      },
      {
        path: '/Catalog/Product-Group-Attachments',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Schemes/Schemes'))
      },
      {
        path: '/Catalog/Schemes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Schemes/Schemes'))
      },
      {
        path: '/Catalog/Status',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Status'))
      },
      {
        path: '/Catalog/Status/AddStatus',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Status/AddStatus'))
      },
      {
        path: '/Catalog/ConsumerTypes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ConsumerTypes'))
      },
      {
        path: '/Catalog/ConsumerTypes/AddConsumerType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ConsumerTypes/AddConsumerType'))
      },
      {
        path: '/Catalog/ConsumerAdressTypes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ConsumerAdressTypes'))
      },
      {
        path: '/Catalog/ConsumerAdressTypes/AddConsumerAdressType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ConsumerAdressTypes/AddConsumerAdressType'))
      },
      {
        path: '/Catalog/WarrantyTypes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/WarrantyTypes'))
      },
      {
        path: '/Catalog/ReworkStatus',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ReworkStatus'))
      },
      {
        path: '/Catalog/ReworkStatus/AddReworkStatu',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ReworkStatus/AddReworkStatu'))
      },
      {
        path: '/Catalog/Labour',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Labour'))
      },
      {
        path: '/Catalog/Labour/AddLabour',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Labour/AddLabour'))
      },
      {
        path: '/Catalog/WarrantyTypes/AddWarrantyType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/WarrantyTypes/AddWarrantyType'))
      },
      {
        path: '/Catalog/RejectReasons',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/RejectReasons'))
      },
      {
        path: '/Catalog/CancellationReasons',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/CancellationReasons'))
      },
      {
        path: '/Catalog/Toinfo',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Toinfo'))
      },
      {
        path: '/OperationCatalog/SurveyModule',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/SurveyModule'))
      },
      {
        path: '/Catalog/RejectReasons/AddRejectReason',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/RejectReasons/AddRejectReason'))
      },
      {
        path: '/Catalog/CancellationReasons/AddCancellationReason',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/CancellationReasons/AddCancellationReason'))
      },
      {
        path: '/Catalog/Places',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Places'))
      },
      {
        path: '/Catalog/Places/AddPlace',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Places/AddPlace'))
      },
      {
        path: '/Catalog/ConsumerPhoneTypes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ConsumerPhoneTypes'))
      },
      {
        path: '/Catalog/ConsumerPhoneTypes/AddConsumerPhoneType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ConsumerPhoneTypes/AddConsumerPhoneType'))
      },
      {
        path: '/Catalog/ApplicationType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Issues'))
      },
      {
        path: '/Catalog/ApplicationType/AddIssue',
        public: true,
        exact: true,
        component: lazy(() =>
          import('src/views/Catalog/Issues/AddIssue')
        )
      },
      {
        path: '/Catalog/AdhocQuery',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/AdhocQuery'))
      },
      {
        path: '/Catalog/AdhocQuery/EditQuery',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/AdhocQuery/EditQuery'))
      },
      {
        path: '/Catalog/PaymentTypes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/PaymentTypes'))
      },
      {
        path: '/Catalog/PaymentTypes/AddPaymentType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/PaymentTypes/AddPaymentType'))
      },
      {
        path: '/Catalog/TaskType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/TaskType'))
      },
      {
        path: '/Catalog/DynamicGroup',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/DynamicGroup'))
      },
      {
        path: '/Catalog/Technology',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/TechnologyType'))
      },
      {
        path: '/Catalog/Technology/AddTechnology',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/TechnologyType/AddTechnologyType'))
      },
      {
        path: '/Catalog/PdfRulesForPriceFields',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/PdfRulesForPriceFields'))
      },
      {
        path: '/Catalog/TaskType/AddTaskType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/TaskType/AddTaskType'))
      },
      {
        path: '/OperationCatalog/Plants',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Plants'))
      },
      {
        path: '/OperationCatalog/Plants/AddPlant',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Plants/AddPlant'))
      },
      {
        path: '/OperationCatalog/Support',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Support'))
      },
      {
        path: '/OperationCatalog/Support',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Support'))
      },
      {
        path: '/SetupTenant',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/index'))
      },
      {
        path: '/SetupTenant/Create',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/CreateTenant/index'))
      },
      {
        path: '/Operation/BulkUpload/WorkOrderUpload',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/BulkUpload/WorkOrderUpload/index'))
      },
      {
        path: '/Operation/BulkUpload/NpsUpload',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/BulkUpload/NpsUpload/index'))
      },
      {
        path: '/SetupTenant/ServiceShop',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/ServiceShop/index'))
      },
      {
        path: '/SetupTenant/AddUpdateProductMaterial',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/AddUpdateProductMaterial/index'))
      },
      {
        path: '/SetupTenant/Distributer',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/Distributer/index'))
      },
      {
        path: '/SetupTenant/Employee',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/Employee/index'))
      },
      {
        path: '/SetupTenant/ServiceEmployeeMatching',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/ServiceEmployeeMatching/index'))
      },
      {
        path: '/SetupTenant/Location',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/Location/index'))
      },
      {
        path: '/SetupTenant/Retailer',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/Retailer/index'))
      },
      {
        path: '/SetupTenant/PostCodeServiceShop',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/PostCodeServiceShop/index'))
      },
      {
        path: '/SetupTenant/VatCurrency',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/VatCurrency/index'))
      },
      {
        path: '/SetupTenant/Product',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/Product/index'))
      },
      {
        path: '/SetupTenant/TransportationRules',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/TransportationRules/index'))
      },
      {
        path: '/SetupTenant/LabourPrice',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/LabourPrice/index'))
      },
      {
        path: '/SetupTenant/UserTypeForEmployee',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/UserTypeForEmployee/index'))
      },
      {
        path: '/SetupTenant/UserType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/UserType/index'))
      },
      {
        path: '/SetupTenant/WarrantyType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/WarrantyTypes/index'))
      },
      {
        path: '/SetupTenant/Status',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/Status/index'))
      },
      {
        path: '/SetupTenant/StatusRelation',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/StatusRelation/index'))
      },
      {
        path: '/SetupTenant/RejectReason',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/RejectReason/index'))
      },
      {
        path: '/SetupTenant/ExchangeReason',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/ExchangeReason/index'))
      },
      {
        path: '/SetupTenant/UpdateTranslation',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/UpdateTranslation/index'))
      },
      {
        path: '/SetupTenant/NpsTranslation',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/SetupTenant/NpsTranslation/index'))
      },

      {
        path: '/Catalog/Vulnerabilities',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Vulnerabilities'))
      },
      {
        path: '/Catalog/Vulnerabilities/AddVulnerability',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Vulnerabilities/AddVulnerability'))
      },
      {
        path: '/Catalog/CustomerTitles',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/CustomerTitles'))
      },
      {
        path: '/Catalog/CustomerTitles/AddCustomerTitle',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/CustomerTitles/AddCustomerTitle'))
      },
      {
        path: '/Catalog/Fls',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Fls'))
      },
      {
        path: '/Catalog/StatusUpdater',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Fls/StatusUpdater'))
      },
      {
        path: '/Catalog/Fls/EditFls',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Fls/EditFls'))
      },
      {
        path: '/Catalog/Fls/EditFlsQA',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/Fls/EditFlsQA'))
      },
      {
        path: '/Bulletin',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Bulletin'))
      },
      {
        path: '/TechnicalSupport',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/TechnicalSupport'))
      },
      {
        path: '/HQSupport',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/HQSupport'))
      },
      {
        path: '/TechnicalKnowledgeBased',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/TechnicalKnowledgeBased'))
      },
      {
        path: '/Sales/ProductForSales',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Sales/ProductForSales'))
      },
      {
        path: '/Operation/MaterialServiceShop',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MaterialServiceShop'))
      },
      {
        path: '/chat/:id',
        exact: true,
        component: lazy(() => import('src/views/Chat'))
      },
      {
        path: '/Chat',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Chat'))
      },
      {
        path: '/Organization/ServiceShop',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Organization/ServiceShop'))
      },
      {
        path: '/Catalog/ServiceShopTypes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ServiceShopTypes'))
      },
      {
        path: '/Catalog/WarrantyPeriods',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/WarrantyPeriods'))
      },
      {
        path: '/OperationCatalog/Brand',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Brand'))
      },
      {
        path: '/Catalog/ServiceShopTypes/AddServiceShopType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/ServiceShopTypes/AddServiceShopType'))
      },
      {
        path: '/Organization/UserTypes',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Organization/UserTypes'))
      },
      {
        path: '/Organization/UserAuthority',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Organization/UserAuthority'))
      },
      {
        path: '/Organization/PaymentTypeTenant',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Organization/PaymentTypeTenant'))
      },
      {
        path: '/Organization/Retailer',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Organization/Retailer'))
      },
      {
        path: '/Organization/UserTypes/AddUserType',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Organization/UserTypes/AddUserType'))
      },
      {
        path: '/Organization/Employee',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Organization/Employee'))
      },
      {
        path: '/Catalog/WorkOrderDetail',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/WorkOrderDetail'))
      },
      ,
      {
        path: '/Operation/ProductExchange',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/ProductExchange'))
      },
      {
        path: '/Operation/JobControl',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/JobControl'))
      },
      {
        path: '/Operation/Scheduling',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/Scheduling'))
      },
      {
        path: '/Operation/SparePartOrderManagement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/SparePartOrderManagement'))
      },
      {
        path: '/Operation/OfferSMS',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/OfferSMS'))
      },
      {
        path: '/Operation/WorkBench',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/WorkBench'))
      },
      {
        path: '/Operation/Triage',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/Triage'))
      },
      {
        path: '/Reports/WarrantyException',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/WarrantyException'))
      },
      {
        path: '/Operation/CustomerFeedback',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/CustomerFeedback'))
      },
      {
        path: '/Operation/GradePosting',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/GradePosting'))
      },
      {
        path: '/Operation/Accounting',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/Accounting'))
      },
      {
        path: '/Operation/WaitingForDiscountApproval',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/WaitingForDiscountApproval'))
      },
      {
        path: '/Operation/ManualDiscount',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/ManualDiscount'))
      },
      {
        path: '/Operation/MaterialOrder/Create/ForConsumer',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/MaterialOrder/Create/ForConsumer'))
      },
      {
        path: '/Operation/MaterialOrder/Create/ForPartner',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/MaterialOrder/Create/ForPartner'))
      },
      {
        path: '/Operation/MaterialOrder/Query',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/MaterialOrder/Query'))
      },
      {
        path: '/Operation/MaterialPhotoUploader',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/MaterialPhotoUploader'))
      },
      {
        path: '/Operation/ServiceCapacity',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/ServiceCapacity'))
      },
      {
        path: '/Operation/SmsNpsManual',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/SmsNpsManual'))
      },
      // {
      //   path: '/OperationCatalog/TaskManagement',
      //   public: true,
      //   exact: true,
      //   component: lazy(() => import('src/views/OperationCatalog/TaskManagement'))
      // },
      {
        path: '/OperationCatalog/Announcement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/Announcement'))
      },
      {
        path: '/OperationCatalog/StatusManagement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/StatusManagement'))
      },
      {
        path: '/OperationCatalog/NotificationCenter',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/NotificationCenter'))
      },
      {
        path: '/OperationCatalog/VerificationExecuteRules',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/VerificationExecuteRules'))
      },
      {
        path: '/OperationCatalog/ExchangeStatus',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ExchangeStatus'))
      },
      {
        path: '/OperationCatalog/ExchangeReason',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ExchangeReason'))
      },
      {
        path: '/OperationCatalog/ExchangeReasonDetail',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ExchangeReasonDetail'))
      },
      {
        path: '/OperationCatalog/ExchangeStatus/AddExchangeStatus',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ExchangeStatus/AddExchangeStatus'))
      },
      {
        path: '/OperationCatalog/ExchangeReason/AddExchangeReason',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ExchangeReason/AddExchangeReason'))
      },
      {
        path: '/OperationCatalog/ExchangeReasonDetail/AddExchangeReasonDetail',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ExchangeReasonDetail/AddExchangeReasonDetail'))
      },
      {
        path: '/OperationCatalog/SparePartMap',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/SparePartMap'))
      },
      {
        path: '/OperationCatalog/ProductAlternative',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ProductAlternative'))
      },
      {
        path: '/MasterDataManagement/Defects',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/Defects'))
      },
      {
        path: '/MasterDataManagement/Defects/AddDefects',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/Defects/AddDefects'))
      },
      {
        path: '/MasterDataManagement/ProductLaunch',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/ProductLaunch'))
      },
      {
        path: '/MasterDataManagement/Conjugate',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/Conjugate'))
      },
      {
        path: '/MasterDataManagement/MaterialConjugate',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/MaterialConjugate'))
      },
      {
        path: '/MasterDataManagement/PriceGroups',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/PriceGroups'))
      },
      {
        path: '/MasterDataManagement/PriceOperation',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/PriceOperation'))
      },
      {
        path: '/MasterDataManagement/LabourOperation',
        public: true,
        exaxt: true,
        component: lazy(() => import('src/views/MasterDataManagement/LabourOperation'))
      },
      {
        path: '/MasterDataManagement/PriceGroups/AddPriceGroup',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/PriceGroups/AddPriceGroup'))
      },
      {
        path: '/MasterDataManagement/ProductLabourRelation',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/ProductLabourRelation'))
      },
      {
        path: '/MasterDataManagement/TransportPrices',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/TransportPrices'))
      },
      {
        path: '/MasterDataManagement/MenuAuthorization',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/MenuAuthorization'))
      },
      {
        path: '/MasterDataManagement/CommentUserAuthorization',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/CommentUserAuthorization'))
      },
      {
        path: '/MasterDataManagement/RevenuePrices',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/RevenuePrices'))
      },
      {
        path: '/MasterDataManagement/InterventionControl',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/InterventionControl'))
      },
      {
        path: '/MasterDataManagement/NoRevenueDefects',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/NoRevenueDefects'))
      },
      {
        path: '/Catalog/PaymentGroups',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Catalog/PaymentGroups'))
      },

      {
        path: '/profile/:id/:tab',
        exact: true,
        component: Profil
      },
      {
        path: '/Reports/AdhocQuery',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/AdhocQuery'))
      },
      {
        path: '/Reports/AdhocQuery/New',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/AdhocQuery/New'))
      },
      // {
      //   path: '/Reports/Sms',
      //   public: true,
      //   exact: true,
      //   component: lazy(() => import('src/views/Reports/Sms'))
      // },
      // {
      //   path: '/Reports/Nps',
      //   public: true,
      //   exact: true,
      //   component: lazy(() => import('src/views/Reports/Nps'))
      // },
      {
        path: '/Reports/ServiceShopMaterial',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/ServiceShopMaterial'))
      },
      {
        path: '/Reports/ServiceShopOffWork',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/ServiceShopOffWork'))
      },
      {
        path: '/Reports/TechnicianOffWork',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/TechnicianOffWork'))
      },
      {
        path: '/Reports/CountryCard',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/CountryCard'))
      },
      {
        path: '/MasterDataManagement/DefinedValues',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/MasterDataManagement/DefinedValues'))
      },
      {
        path: '/Reports/PostCode',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/PostCode'))
      },
      {
        path: '/Reports/IntegrationControl',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/IntegrationControl'))
      },
      {
        path: '/Reports/GatewayIntegrationControl',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/GatewayIntegrationControl'))
      },
      {
        path: '/Reports/GeneralReports',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Reports/GeneralReports'))
      },
      {
        path: '/Operation/FleetCostManagement',
        exact: true,
        component: lazy(() => import('src/views/Operation/FleetCostManagement'))
      },
      {
        path: '/Reports/ReworkPdf',
        exact: true,
        component: lazy(() => import('src/views/Reports/ReworkPdf'))
      },
      {
        path: '/Operation/UploadRework',
        exact: true,
        component: lazy(() => import('src/views/Operation/UploadRework'))
      },
      {
        path: '/Operation/ExcelToCase',
        exact: true,
        component: lazy(() => import('src/views/Operation/ExcelToCase'))
      },
      {
        path: '/Operation/Compensation',
        exact: true,
        component: lazy(() => import('src/views/Operation/Compensation'))
      },
      {
        path: '/Operation/AutomaticSAPDocuments',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/AutomaticSAPDocuments'))
      },
      {
        path: '/Operation/SerialNumber',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/SerialNumber'))
      },
      {
        path: '/Operation/CaseOwner',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Operation/CaseOwner'))
      },
      {
        path: '/OperationCatalog/ServiceShopDiscountGradeManagement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ServiceShopDiscountGradeManagement'))
      },
      {
        path: '/OperationCatalog/ServiceShopStorageLocationManagement',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ServiceShopStorageLocationManagement'))
      },
      {
        path: '/OperationCatalog/ServiceShopPaymentGroupManagement',
        exact: true,
        component: lazy(() => import('src/views/OperationCatalog/ServiceShopPaymentGroupManagement'))
      },
      {
        path: '/Operation/AccountingFinalOperations',
        public: true,
        exact: true,
        component: lazy(() => import('src/views/Accounting/FinalOperations'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
